const routes = [
    {
      path: "auditlog",
      name: "auditlog_page",
      component: () => import(/* webpackChunkName: "AuditlogListPage" */ "@/modules/auditlog/views/AuditlogListPage.vue") ,
    },
];
export default routes;
